import cn from '@/utils/classnames';
import { useMemo } from 'react';
interface ProgressBarProps {
  progress: number;
  type?: 'warning' | 'primary' | 'danger' | 'default' | 'success';
  className?: string;
  barClassName?: string;
  /** @des 进度条为0时展示的进度，默认2% */
  progressPlaceholder?: number;
}

const ProgressBar = ({ progress, type = 'default', className, barClassName, progressPlaceholder = 2 }: ProgressBarProps) => {
  const typeClassName = useMemo(() => {
    return {
      primary: 'bg-accent-blue',
      warning: 'bg-pending',
      danger: 'bg-danger',
      success: 'bg-success',
      default: 'bg-accent-blue',
    }[type];
  }, [type]);
  return (
    <div className={cn("w-full h-[10px] flex items-center relative", className)}>
      <div className="absolute top-0 left-0 w-full h-full rounded-full overflow-hidden flex">
        <div
          className={cn("h-full flex items-center rounded-full", typeClassName, barClassName)}
          style={{ width: `${progress || progressPlaceholder}%` }} // 700/1000 = 70%
        />
        <div
          className="h-full bg-[rgba(255,255,255,0.08)] flex-1"
        />
      </div>
    </div>
  );
};

export default ProgressBar;